export var redirectToURL = function redirectToURL(url) {
  window.open(url, '_blank');
};